<template>
  <div id="demo">312312</div>
</template>


<script>
export default {
  name: "Read",
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/views/Read.vue